var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"song-list"},[_vm._l((_vm.songs),function(song,index){return _c('Songs',{key:index,staticClass:"song",attrs:{"song":song,"albumId":_vm.albumId}})}),(_vm.totalSongs == 0)?_c('p',{staticClass:"medium no-song pt-4 pb-4"},[_vm._v(" No Song ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }